"use strict";

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { EaselPlugin } from "gsap/EaselPlugin";
import Vivus from "vivus";
import { slideDown, slideUp } from "slide-anim";
import "pace-progressbar";
gsap.registerPlugin(ScrollTrigger);

gsap
  .timeline({
    defaults: {
      ease: "power2.out",
      duration: 1,
    },
  })
  .to(".loading", {
    opacity: 0,
    zIndex: -100,
  });

new Vivus("businesstxt01", {
  type: "oneByOne",
  start: "inViewport",
  duration: 80,
  forceRender: false,
  animTimingFunction: Vivus.LINEAR,
});

new Vivus("businesstxt02", {
  type: "oneByOne",
  start: "inViewport",
  duration: 80,
  forceRender: false,
  animTimingFunction: Vivus.LINEAR,
});

// トリガークラス'.js-accordion'を持つ要素を取得
const accordionTrigger = $(".about-flow-accordion-cont__close");
// トリガーを押した時のアクション

accordionTrigger.on("click", function () {
  // クリックされた要素（トリガー要素）を取得
  let currentElement = $(this);

  // 同じ親要素を持つ隣接した次の要素'.js-accordion'（展開対象の要素）を取得
  let accordionTargetWrap = $(this).closest(".js-accordion-wrap");
  let accordionTarget = accordionTargetWrap.find(".about-flow-accordion-cont");
  let ttlCmnBtn = accordionTargetWrap.find(".about-flow-accordion-ttl__btn");
  //トリガーの'is-active'クラスを削除
  currentElement.removeClass("is-active");
  ttlCmnBtn.removeClass("is-open");
  accordionTarget.slideUp();
});

/**
 * スクロールイベント登録
 */
window.addEventListener(
  "scroll",
  function () {
    toggleClassWithScroll(`.about-link`, `.about-lead`, `is-fixed`);
    toggleClassWithScroll(`body`, `.about-lead`, `is-tag-fixed`);
  },
  false
);
/**
 * 指定した位置まで要素がスクロールした時に、classを追加する
 *
 * @param selector クラスを追加したい要素
 * @param className 追加したいクラス名
 */

function toggleClassWithScroll(target, selector, className) {
  let elements = document.querySelectorAll(selector);
  let targets = document.querySelectorAll(target);

  Array.prototype.forEach.call(elements, function (element, index) {
    // windowの高さ - a
    let windowHeight = window.document.documentElement.clientHeight;

    // 現在のスクロール量
    let scrollTop =
      document.documentElement.scrollTop || document.body.scrollTop;

    // 画面左上から要素までの高さ - b
    let rect = element.getBoundingClientRect();
    let offset = rect.top + scrollTop;

    // 要素が画面に表示されるスクロール量(a - b)
    let scrollHeight = offset - windowHeight;

    // 画面の1/4を超えたら、classを追加
    if (scrollTop > scrollHeight + windowHeight / 2) {
      targets.forEach((target) => {
        target.classList.add(className);
      });
    } else {
      targets.forEach((target) => {
        target.classList.remove(className);
      });
    }
  });
}
